import { render, staticRenderFns } from "./ResponderFormulario.vue?vue&type=template&id=a1e5296c&scoped=true&"
import script from "./ResponderFormulario.vue?vue&type=script&lang=js&"
export * from "./ResponderFormulario.vue?vue&type=script&lang=js&"
import style0 from "./ResponderFormulario.vue?vue&type=style&index=0&id=a1e5296c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e5296c",
  null
  
)

export default component.exports